<template>
  <v-row row wrap v-if="kategori" class="">
    <v-col cols="12">
      <m-card>
        <v-row wrap>
          <v-col cols="12" sm="12" md="12">
            <div class="d-flex justify-space-between">
              <div class="ml-n4"><m-breadcrum :items="bread"></m-breadcrum></div>
              <v-btn v-if="isCan('cuti-kategori.update') && Number(getDeepObj(kategori, 'is_aktif')) === 1 && Number(kategori.is_sistem) === 0" depressed icon class="rounded mr-3 pa-5 grey lighten-3" small @click="edit">
                <v-icon color="grey darken-1">mdi-pencil</v-icon>
              </v-btn>
            </div>
            <div class="text-h6 black--text">Detail Kategori Cuti </div>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <div class="text-center">
              <v-avatar tile size="150" color="deep-purple lighten-5">
                <v-icon size="60" color="primary">mdi-calendar</v-icon>
              </v-avatar>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <div class="grey--text">Label Kategori Cuti</div>
            <div class="primary--text text-h6 font-weight-regular">{{ getDeepObj(kategori, 'nama') }}</div>
            <div class="grey--text font-italic">
              Masa Berlaku Cuti
              <template v-if="getDeepObj(kategori, 'tgl_mulai') && getDeepObj(kategori, 'tgl_selesai')">
                {{ duration(getDeepObj(kategori, 'tgl_mulai'), getDeepObj(kategori, 'tgl_selesai')) }}
              </template>
              <template v-else> Tidak ada batasan waktu </template>
            </div>
            <div class="mt-5 text-h6 font-weight-regular black--text"> Kebijakan Cuti </div>
            <div v-for="(rule, r) in rules" :key="r" class="d-flex justify-space-between mt-2">
              <div>{{ rule.label }}</div>
              <div class="font-weight-bold">
                {{ rule.value }}
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="3" class="ml-10">
            <v-card outlined class="pa-5" style="border: 1pt #7f79d9 solid; border-radius: 10pt">
              <v-card-text>
                <div class="text-center">
                  <h1 class="text-h3 primary--text">{{ kategori.jumlah }}</h1>
                  <div>Jatah Cuti Pertahun</div>
                </div>
              </v-card-text>
            </v-card>
            <v-card outlined class="mt-2 pa-5" style="border: 1pt #7f79d9 solid; border-radius: 10pt">
              <v-card-text>
                <div class="text-center">
                  <h1 class="text-h3">{{ kategori.masa_kerja }}</h1>
                  <div>Masa Kerja Dalam Bulan</div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </m-card>
    </v-col>
    <ChangeDlg ref="dlg" />
  </v-row>
</template>
<script>
import { duration } from '../../../tools'
import ChangeDlg from '../components/Form.vue'

export default {
  components: { ChangeDlg },
  data() {
    return {
      kategori: null,
    }
  },
  computed: {
    bread() {
      return [
        {
          icon: 'mdi-calendar-text',
          title: 'Kategori',
          to: {
            name: 'kategori',
            params: { organisasi_id: this.organisasi_id },
          },
        },
        {
          icon: 'mdi-clock',
          title: this.kategori && this.kategori.nama,
        },
      ]
    },
    rules() {
      const kategori = this.kategori || {}
      return [
        {
          label: 'Menerapkan Cuti Tahunan ?',
          value: kategori.is_cuti_tahunan ? 'Ya' : 'Tidak',
        },
        {
          label: 'Memerlukan Masa Kerja Tertentu ?',
          value: kategori.is_masa_kerja ? 'Ya' : 'Tidak',
        },
        {
          label: 'Menerapkan Persetujuan Berjenjang ?',
          value: kategori.is_setuju ? 'Ya' : 'Tidak',
        },
        {
          label: 'Menerapkan Jatah Cuti ?',
          value: kategori.is_saldo ? 'Ya' : 'Tidak',
        },
        {
          label: 'Jatah Cuti Per Tahun',
          value: kategori.jumlah,
        },
        {
          label: 'Maksimal Ajuan berturut-turut',
          value: kategori.max_ajuan,
        },
        {
          label: 'Sisa Saldo dapat diakumulasi ke periode selanjutnya?',
          value: kategori.is_akumulasi ? 'Ya' : 'Tidak',
        },
        {
          label: 'Jumlah Sisa Cuti yang dapat diakumulasi',
          value: kategori.max_sisa_cuti_diambil,
        },
        {
          label: 'Keterkaitan Cuti dalam tahun berjalan?',
          value: kategori.is_related ? 'Ya' : 'Tidak',
        },
        {
          label: 'Mewajibkan Unggah Lampiran ?',
          value: kategori.is_lampiran ? 'Ya' : 'Tidak',
        },
        {
          label: 'Wajib mengisi kolom keterangan?',
          value: kategori.is_keterangan ? 'Ya' : 'Tidak',
        },
      ]
    },
  },
  activated() {
    this.load()
  },
  methods: {
    duration,
    load() {
      this.$store
        .dispatch('kategori/detail', {
          organisasi_id: this.organisasi_id,
          kategori_id: this.$route.params.kategori_id,
        })
        .then((res) => {
          this.page = res.data
          this.kategori = res.data
        })
        .catch((e) => e)
    },
    async edit() {
      const item = await this.$store
        .dispatch('kategori/detail', { organisasi_id: this.organisasi_id, kategori_id: this.$route.params.kategori_id })
        .then(({ data }) => data)
      this.$refs.dlg.open(item).then(() => {
        this.load()
      })
    },
  },
}
</script>
